import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import IFilter from "models/IFilter";
import Input from "components/Input";
import Select from "components/Select";
import DetailView from "components/DetailView";
import RangeDatepicker from "components/RangeDatepicker";
import Button from "components/Button";
import FilterGenerator from "helpers/filter";
import withFilters from "helpers/withFilters";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps extends IFilter {
  typeOptions: any[];
}

class ReportsSearch extends React.Component<IProps> {
  public static getInputQuery = (value) => {
    const Q = new FilterGenerator();

    Q.and("BatchNumber", value);
    Q.or("ItemDescription", value);
    Q.or("SupplierName", value);

    return Q.query;
  };

  public static getFilterQuery = (f) => {
    const Q = new FilterGenerator();

    if (!_.isEmpty(f.date)) {
      Q.and("Date", f.date, "dateRange");
    }
    Q.and("BatchNumber", f.batchNumber);
    Q.and("SupplierName", f.supplierName);
    Q.and("ItemDescription", f.description);
    Q.and("OrderNumber", f.orderNumber);
    Q.and("TypeId", f.type && f.type.value, "string");

    return Q.query;
  };

  public render = () => {
    const {
      filter,
      handleFilterChange,
      generateFilter,
      resetFilter,
      typeOptions,
    } = this.props;

    return (
      <DetailView
        pageName={CUSTOM_SETTINGS.qualityReport}
        renderExpanded={() => (
          <div>
            <div className="filter-row">
              <div className="inner-block">
                <FormattedMessage id="REPORTS_TYPE" tagName="label" />
                <Select
                  options={typeOptions}
                  selectedOption={filter.type}
                  onChange={(value) => handleFilterChange(value, "type")}
                  className="min-width-select-forms"
                />
              </div>
              <Input
                label="ORDERS_NUMBER"
                value={filter.orderNumber}
                onChange={(e) =>
                  handleFilterChange(e.target.value, "orderNumber")
                }
              />
            </div>
            <div className="filter-row">
              <RangeDatepicker
                name="date"
                label="DATE"
                value={filter.date}
                handleRangeChange={handleFilterChange}
              />
            </div>
          </div>
        )}
      >
        <div className="filter-row">
          <Input
            label="REPORTS_NR"
            value={filter.batchNumber}
            onChange={(e) => handleFilterChange(e.target.value, "batchNumber")}
          />
          <Input
            label="RECEIPTS_SUPPLIER"
            value={filter.supplierName}
            onChange={(e) => handleFilterChange(e.target.value, "supplierName")}
          />
        </div>
        <div className="filter-row">
          <Input
            label="ARTICLE_DESCRIPTION"
            value={filter.description}
            onChange={(e) => handleFilterChange(e.target.value, "description")}
          />
        </div>
        <div className="search-btn">
          <Button onClick={resetFilter}>RESET</Button>
          <Button kind="primary" onClick={generateFilter}>
            SEARCH
          </Button>
        </div>
      </DetailView>
    );
  };
}

export default withFilters({
  placeholder: "REPORTS_SEARCH",
  pageName: CUSTOM_SETTINGS.qualityReport,
})(ReportsSearch);
